import { api } from './client'

export const getKpis = async (params = {}) => {
  const { data } = await api.get('/dashboard/kpis', { params })
  return data
}

export const getPLBars = async (params = {}) => {
  const { data } = await api.get('/dashboard/pl-bars', { params })
  return data
}

export const getTrendDaily = async (params = {}) => {
  const { data } = await api.get('/dashboard/trend', { params })
  return data
}

export const getTopProducts = async (params = {}) => {
  const { data } = await api.get('/dashboard/top-products', { params })
  return Array.isArray(data) ? data : []
}

export const getTopProductsMonthly = async (params = {}) => {
  const { data } = await api.get('/dashboard/top-products-monthly', { params })
  if (!data || typeof data !== 'object') return { labels: [], series: [], metric: params?.metric || 'revenue' }
  return data
}

export const getLowStock = async (params = {}) => {
  const { data } = await api.get('/dashboard/low-stock', { params })
  return Array.isArray(data) ? data : []
}

/** Open customer invoices by customer, aged: { as_of, customers: [...], totals }. */
export const getArAging = async (params = {}) => {
  const { data } = await api.get('/dashboard/ar-aging', { params })
  return data
}

export const getApAging = async (params = {}) => {
  const { data } = await api.get('/dashboard/ap-aging', { params })
  return data
}
